<template>
  <div>
    <base-title
      title="Google Tag Manager"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input type="checkbox" id="toggle-checkbox" v-model="toggleOn" />

            <div
              class="toggle-control"
              :class="toggleOn ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ toggleOn ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          placeholder="Código"
          class="w-100"
          v-model="code"
          :valid="registerValid"
          @blur="validateCode"
          @focus="registerValid = true"
        />

        <div @click="save()" class="d-flex justify-end mt_20">
          <base-button text="Salvar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
import StoreAPI from '@/api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      toggleOn: true,
      code: '',
      backRoute: 'google-tag-manager',
      registerValid: true,
    };
  },
  async created() {
    const response = await StoreAPI.storeGetConfiguration();

    const configuration = response.getData([]);

    if (configuration.tagManager) {
      this.toggleOn = configuration.tagManager.active;
      this.code = configuration.tagManager.code;
      this.backRoute = 'integracoes';
    }
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    },
    validateCode() {
      if (this.code.startsWith('GTM-')) {
        if (
          !(this.code.split('-')[1].length == 7) &&
          !(this.code.split('-')[1].length == 0)
        ) {
          this.registerValid = false;
          return;
        }
        this.registerValid = true;
        return;
      }
      this.registerValid = false;
    },
    async save() {
      if (this.code.length === 0 || !this.code) {
        this.registerValid = false;
        return;
      }

      const response = await StoreAPI.storeConfiguration({
        tagManager: {
          code: this.code,
          active: this.toggleOn,
        },
      });

      if (response.getErrors([]).length > 0) {
        this.registerValid = false;
        alert('Ocorreu um error');
      }

      this.backRoute = 'integracoes';
    },
  },
};
</script>
